module.exports = __webpack_public_path__ + "static/media/leavenew.8fde975c.svg";